import React, { useEffect, useState } from 'react';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/id';
import 'moment/locale/id';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/tr';
import 'moment/locale/uk';
import { jwtDecode } from 'jwt-decode';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import moment from 'moment-timezone';

import * as Env from 'widget/env';

import { putInLocalStorage } from './actions';
import { WidgetIcons } from './components';
import Content from './content/content';
import WidgetContext from './widget-context';

const widgetEl = document.getElementById('whatcrm-widget');
const { dataset } = widgetEl || {};

const platform = dataset?.platform ?? null;
const tariff = (dataset?.tariff || null) as Env.Tariff;
const widget: Env.Widget | null = dataset?.id ? jwtDecode(dataset?.id) : null;

const Widget = () => {
  const [isWidgetActive, setIsWidgetActive] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const utmParams = {
      utm_campaign: urlSearchParams.get('utm_campaign'),
      utm_content: urlSearchParams.get('utm_content'),
      utm_medium: urlSearchParams.get('utm_medium'),
      utm_source: urlSearchParams.get('utm_source'),
      utm_term: urlSearchParams.get('utm_term'),
    };

    const utm = Object.fromEntries(
      Object.entries(utmParams).filter(([, value]) => Boolean(value)),
    );

    if (!Object.values(utm).some(Boolean)) return;
    putInLocalStorage('whatcrmWidgetUtm', JSON.stringify(utm));
  }, []);

  useEffect(() => {
    moment.locale(i18n.resolvedLanguage);
  }, []);

  return (
    <>
      {widget && (
        <WidgetContext.Provider
          value={{
            isWidgetActive,
            platform,
            setIsWidgetActive,
            tariff,
            widget,
          }}
        >
          <div
            className={cn('whatcrm-widget', {
              'whatcrm-widget-dark-theme': widget.theme == 'dark',
            })}
          >
            <WidgetIcons />
            <Content />
          </div>
        </WidgetContext.Provider>
      )}
    </>
  );
};

export default Widget;
